import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Submotive4ActionsProps } from './props';
import { useSubmotive4ListActions } from './hook';

export const Submotive4ListActions = ({ id }: Submotive4ActionsProps) => {
    const { handleEdit } = useSubmotive4ListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
